import { isPlatformBrowser } from '@angular/common';
import { inject, Injectable, PLATFORM_ID } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  Router,
  RouterStateSnapshot,
  UrlTree,
} from '@angular/router';
import { ReferralNavService } from '../referral-nav/referral-nav.service';
import { HeaderService } from '../headerService';

/**
 * Class-based guard aligned with legacy Applicant `AuthGuard`:
 * only `appbearer` grants access; enables applicant nav; else redirect to root (`''`).
 */
@Injectable({ providedIn: 'root' })
export class AuthGuard implements CanActivate {
  private router = inject(Router);
  public navigationBar = inject(ReferralNavService);
  private headerService = inject(HeaderService);
  private platformId = inject(PLATFORM_ID);

  canActivate(
    _route: ActivatedRouteSnapshot,
    _state: RouterStateSnapshot
  ): boolean | UrlTree {
    if (!isPlatformBrowser(this.platformId)) {
      return true;
    }

    const applicantToken = localStorage.getItem('appbearer');
    if (applicantToken) {
      this.headerService.setHeaderVisibility(true);
      this.navigationBar.showApplicantNavigation();
      return true;
    }
    this.headerService.setHeaderVisibility(false);
    return this.router.createUrlTree(['']);
  }

  isApplicantLoggedIn(): boolean {
    if (!isPlatformBrowser(this.platformId)) {
      return false;
    }
    return !!localStorage.getItem('appbearer');
  }
}
